import React from "react";
import { injectIntl } from "react-intl";
import "./statisticsCard.scss";

const StatisticsCards = ({
  intl: { messages },
  number,
  title,
  icon,
  classes,
}) => {
  return (
    <div className="card-wrapper">
      <div className="card-wrapper_content d-flex justify-content-between align-items-center w-100">
        <p className="card-wrapper_content_number">{number}</p>
        {icon ? <div className={`${classes} icon-wrapper`}>{icon}</div> : 
        <div className={`${classes} icon-space`}></div>}
      </div>
      <p className="card-wrapper_content_title">{title}</p>
    </div>
  );
};

export default injectIntl(StatisticsCards);
